/**
 * ThesisRelevantReads — Strategy Insights section 4.
 * kb_items where agent_type='article' AND sector_tags overlap thesis focus.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DS_COLORS, DS_SPACING, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { copy } from '@/content/copy';
import { SectionRegenWrap } from '@/components/strategy-insights/SectionRegenWrap';
import { ROUTES } from '@/config/product-contract';

export function ThesisRelevantReads({ reads = [], onResynth }) {
  return (
    <SectionRegenWrap title={copy.strategyInsights.sections.thesisReads} onResynth={onResynth}>
      {reads.length === 0 ? (
        <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.secondary, margin: 0 }}>
          {copy.strategyInsights.empty.thesisReads}
        </p>
      ) : (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {reads.map((r) => (
            <li
              key={r.id}
              data-regen-key={r.id}
              style={{
                padding: `${DS_SPACING.labelToContent}px 0`,
                borderBottom: `1px solid ${DS_COLORS.border.default}`,
              }}
            >
              <a
                href={`${ROUTES.KNOWLEDGE_BASE}?id=${r.id}`}
                style={{
                  ...DS_TYPOGRAPHY.listItemTitle,
                  color: DS_COLORS.text.primary,
                  textDecoration: 'none',
                  display: 'block',
                  marginBottom: DS_SPACING.labelToContent / 2,
                }}
              >
                {r.title}
              </a>
              {r.sector_tags && (
                <span style={{ ...DS_TYPOGRAPHY.sectionSubLabel, color: DS_COLORS.text.secondary }}>
                  {r.sector_tags.join(' · ')}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </SectionRegenWrap>
  );
}

ThesisRelevantReads.propTypes = {
  reads: PropTypes.array,
  onResynth: PropTypes.func,
};

export default ThesisRelevantReads;
